var ibanReplaceLetters = function (str) {
    return str.replace(/[A-Z]/g, function (ch) { return String(ch.charCodeAt(0) - 55); });
};
var validateIban = function (value) {
    if (value === null || value === undefined || value === '')
        return true;
    var cleaned = value.replace(/[^0-9a-zA-Z]/g, '');
    if (cleaned.length <= 4)
        return false;
    if (cleaned.substring(0, 2).toUpperCase() === 'BE' && cleaned.length !== 16)
        return false;
    var toTest = cleaned.substring(4) + cleaned.substring(0, 4);
    var numeric = ibanReplaceLetters(toTest.toUpperCase());
    var remainder = '';
    var chunk = numeric;
    while (chunk.length > 9) {
        var numTest = remainder + chunk.substring(0, 9);
        chunk = chunk.substring(9);
        remainder = String(parseInt(numTest, 10) % 97);
    }
    var finalNum = remainder + chunk;
    return parseInt(finalNum, 10) % 97 === 1;
};
export default validateIban;
